import { render, staticRenderFns } from "./CodeDiff.vue?vue&type=template&id=77c9d7bd&scoped=true&"
import script from "./CodeDiff.vue?vue&type=script&lang=js&"
export * from "./CodeDiff.vue?vue&type=script&lang=js&"
import style0 from "./CodeDiff.vue?vue&type=style&index=0&id=77c9d7bd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c9d7bd",
  null
  
)

export default component.exports